import { useEffect, useState } from 'react';
import api from '../../hooks/useApi';
import { formatMoney } from '../../utils/format';
import { normaliseName } from '../../utils/hardwareRequestPrefill';
import HowToOrder from '../shared/HowToOrder';

// Every supplier the Product Catalogue lists for a product, with its price, lead
// time and how to order from it, so whoever is buying can see where it comes
// from without opening the catalogue. Pass `suppliers` when the caller already
// has them; otherwise they are fetched for `productId`. `onRequest` names the
// supplier on the request, which is marked in the list.
export default function CatalogueSuppliers({ productId, suppliers: given, onRequest }) {
  const [fetched, setFetched] = useState(null);

  useEffect(() => {
    if (given || !productId) return;
    let live = true;
    api.get(`product-catalog/${productId}/suppliers`)
      .then(r => { if (live) setFetched(r || []); })
      .catch(() => { if (live) setFetched([]); });
    return () => { live = false; };
  }, [productId, given]);

  const list = given || fetched || [];
  if (!list.length) return null;
  const chosen = normaliseName(onRequest);

  return (
    <div className="bg-white border border-gray-200 rounded" data-testid="catalogue-suppliers">
      <div className="px-2 py-1 border-b border-gray-200 bg-gray-50 text-[8px] font-bold text-gray-500 uppercase">
        Catalogue supplier{list.length === 1 ? '' : `s (${list.length})`}
      </div>
      <table className="w-full text-[9px]">
        <thead>
          <tr className="text-[7px] uppercase text-gray-400">
            <th className="px-2 py-0.5 text-left font-bold">Supplier</th>
            <th className="px-2 py-0.5 text-left font-bold">SKU</th>
            <th className="px-2 py-0.5 text-right font-bold">Price</th>
            <th className="px-2 py-0.5 text-right font-bold">Lead</th>
            <th className="px-2 py-0.5 text-left font-bold">How to order</th>
          </tr>
        </thead>
        <tbody>
          {list.map(s => (
            <tr key={s.id} className="border-t border-gray-100 align-top">
              <td className="px-2 py-1 font-semibold text-navy">
                {s.supplier_name}
                {!!s.is_preferred && <span className="ml-1 inline-block whitespace-nowrap text-[7px] font-bold px-1 py-0.5 bg-emerald-50 text-emerald-700 rounded">Preferred</span>}
                {chosen && normaliseName(s.supplier_name) === chosen && <span className="ml-1 inline-block whitespace-nowrap text-[7px] font-bold px-1 py-0.5 bg-blue-50 text-blue-700 rounded">On request</span>}
              </td>
              <td className="px-2 py-1 font-mono text-gray-500 whitespace-nowrap">{s.supplier_sku || '—'}</td>
              <td className="px-2 py-1 text-right">{parseFloat(s.unit_price) > 0 ? formatMoney(s.unit_price) : '—'}</td>
              <td className="px-2 py-1 text-right text-gray-500">{s.lead_time_days ? `${s.lead_time_days}d` : '—'}</td>
              <td className="px-2 py-1 text-gray-700">
                {s.how_to_order ? <HowToOrder text={s.how_to_order} /> : <span className="text-gray-300">—</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
